const targetUrlEscape = (str) => str.toLowerCase().replace(' ', '-')

export default targetUrlEscape